module.exports = __webpack_public_path__ + "static/media/replace.306c7d89.svg";